import emojiStar from '../../../assets/img/emoji/emoji-star-16.png';
import emojiStar2x from '../../../assets/img/emoji/emoji-star-16@2x.png';

export default function Star(props) {
  return <img src={emojiStar} srcSet={`${emojiStar2x} 2x`} {...props} />;
}

export function Stars({ count, ...props }) {
  return (
    <span className="inline-flex flex-row items-center gap-x-0.5">
      {[...new Array(count)].map((_, i) => (
        <Star key={i} {...props} />
      ))}
    </span>
  );
}
